import React from 'react'
import { FoodMealSectionComponent } from './FoodMealSectionComponent'
import { Col, Row } from 'antd'

export const FoodMealDayComponent = ({
    setLoading,
    showMessage,
    foodListPeriodId,
    dayId,
    dayTitle,
}) => {
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    {dayTitle}
                </h2>
            </div>
            <div className='container'>
                <Row>
                    <Col span={5}>
                        <FoodMealSectionComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            foodListPeriodId={foodListPeriodId}
                            dayId={dayId}
                            foodSectionId={0}
                            foodSectionTitle={"سحری"}
                        />
                    </Col>
                    <Col span={4}>
                        <FoodMealSectionComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            foodListPeriodId={foodListPeriodId}
                            dayId={dayId}
                            foodSectionId={1}
                            foodSectionTitle={"صبحانه"}
                        />
                    </Col>
                    <Col span={5}>
                        <FoodMealSectionComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            foodListPeriodId={foodListPeriodId}
                            dayId={dayId}
                            foodSectionId={2}
                            foodSectionTitle={"ناهار"}
                        />
                    </Col>
                    <Col span={5}>
                        <FoodMealSectionComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            foodListPeriodId={foodListPeriodId}
                            dayId={dayId}
                            foodSectionId={3}
                            foodSectionTitle={"افطاری"}
                        />
                    </Col>
                    <Col span={5}>
                        <FoodMealSectionComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            foodListPeriodId={foodListPeriodId}
                            dayId={dayId}
                            foodSectionId={4}
                            foodSectionTitle={"شام"}
                        />
                    </Col>
                </Row>
            </div>

        </>
    )
}

